export const airPressure = [
  {
    x: 0,
    y: 17.08099999999999,
  },
  {
    x: 20,
    y: 17.6669,
  },
  {
    x: 40,
    y: 18.252800000000008,
  },
  {
    x: 60,
    y: 18.708499999999987,
  },
  {
    x: 80,
    y: 19.164199999999994,
  },
  {
    x: 100,
    y: 19.6199,
  },
  {
    x: 120,
    y: 20.14070000000001,
  },
  {
    x: 140,
    y: 20.531299999999987,
  },
  {
    x: 160,
    y: 20.921899999999994,
  },
  {
    x: 180,
    y: 21.3776,
  },
  {
    x: 200,
    y: 21.768200000000007,
  },
  {
    x: 220,
    y: 22.158800000000014,
  },
  {
    x: 240,
    y: 22.679599999999994,
  },
  {
    x: 260,
    y: 23.0051,
  },
  {
    x: 280,
    y: 23.460800000000006,
  },
  {
    x: 300,
    y: 23.916500000000013,
  },
  {
    x: 320,
    y: 24.24199999999999,
  },
  {
    x: 340,
    y: 24.632599999999996,
  },
  {
    x: 360,
    y: 24.893,
  },
  {
    x: 380,
    y: 25.348700000000008,
  },
  {
    x: 400,
    y: 25.804399999999987,
  },
  {
    x: 420,
    y: 26.06479999999999,
  },
  {
    x: 440,
    y: 26.390299999999996,
  },
  {
    x: 460,
    y: 26.780900000000003,
  },
  {
    x: 480,
    y: 27.17150000000001,
  },
  {
    x: 500,
    y: 27.431900000000013,
  },
  {
    x: 520,
    y: 27.69229999999999,
  },
  {
    x: 540,
    y: 28.082899999999995,
  },
  {
    x: 560,
    y: 28.213099999999997,
  },
  {
    x: 580,
    y: 28.4084,
  },
  {
    x: 600,
    y: 28.603700000000003,
  },
  {
    x: 620,
    y: 28.799000000000007,
  },
  {
    x: 640,
    y: 25.54400000000001,
  },
  {
    x: 660,
    y: 22.158800000000014,
  },
  {
    x: 680,
    y: 21.442700000000002,
  },
  {
    x: 700,
    y: 21.703100000000006,
  },
  {
    x: 720,
    y: 21.96350000000001,
  },
  {
    x: 740,
    y: 21.89840000000001,
  },
  {
    x: 760,
    y: 21.572900000000004,
  },
  {
    x: 780,
    y: 21.442700000000002,
  },
  {
    x: 800,
    y: 21.442700000000002,
  },
  {
    x: 820,
    y: 21.442700000000002,
  },
  {
    x: 840,
    y: 21.442700000000002,
  },
  {
    x: 860,
    y: 21.442700000000002,
  },
  {
    x: 880,
    y: 21.3776,
  },
  {
    x: 900,
    y: 21.3125,
  },
  {
    x: 920,
    y: 21.3125,
  },
  {
    x: 940,
    y: 21.3125,
  },
  {
    x: 960,
    y: 21.3125,
  },
  {
    x: 980,
    y: 21.3125,
  },
  {
    x: 1000,
    y: 21.3125,
  },
  {
    x: 1020,
    y: 21.2474,
  },
  {
    x: 1040,
    y: 21.2474,
  },
  {
    x: 1060,
    y: 15.713899999999995,
  },
  {
    x: 1080,
    y: 7.1858,
  },
  {
    x: 1100,
    y: 4.972399999999993,
  },
  {
    x: 1120,
    y: 4.516699999999986,
  },
  {
    x: 1140,
    y: 4.191200000000009,
  },
  {
    x: 1160,
    y: 4.451600000000013,
  },
  {
    x: 1180,
    y: 4.77709999999999,
  },
  {
    x: 1200,
    y: 5.493200000000002,
  },
  {
    x: 1220,
    y: 6.01400000000001,
  },
  {
    x: 1240,
    y: 6.339499999999987,
  },
  {
    x: 1260,
    y: 6.339499999999987,
  },
  {
    x: 1280,
    y: 6.209300000000013,
  },
  {
    x: 1300,
    y: 6.079100000000011,
  },
  {
    x: 1320,
    y: 6.01400000000001,
  },
  {
    x: 1340,
    y: 5.948900000000009,
  },
  {
    x: 1360,
    y: 5.883800000000008,
  },
  {
    x: 1380,
    y: 5.818700000000007,
  },
  {
    x: 1400,
    y: 5.818700000000007,
  },
  {
    x: 1420,
    y: 5.818700000000007,
  },
  {
    x: 1440,
    y: 5.753600000000006,
  },
  {
    x: 1460,
    y: 5.688500000000005,
  },
  {
    x: 1480,
    y: 5.753600000000006,
  },
  {
    x: 1500,
    y: 5.623400000000004,
  },
  {
    x: 1520,
    y: 5.623400000000004,
  },
  {
    x: 1540,
    y: 5.623400000000004,
  },
  {
    x: 1560,
    y: 5.558300000000003,
  },
  {
    x: 1580,
    y: 5.428100000000001,
  },
  {
    x: 1600,
    y: 5.428100000000001,
  },
  {
    x: 1620,
    y: 5.493200000000002,
  },
  {
    x: 1640,
    y: 5.428100000000001,
  },
  {
    x: 1660,
    y: 5.428100000000001,
  },
  {
    x: 1680,
    y: 5.428100000000001,
  },
  {
    x: 1700,
    y: 5.3629999999999995,
  },
  {
    x: 1720,
    y: 5.2978999999999985,
  },
  {
    x: 1740,
    y: 5.2978999999999985,
  },
  {
    x: 1760,
    y: 5.2327999999999975,
  },
  {
    x: 1780,
    y: 5.167699999999996,
  },
  {
    x: 1800,
    y: 5.167699999999996,
  },
  {
    x: 1820,
    y: 5.167699999999996,
  },
  {
    x: 1840,
    y: 5.102599999999995,
  },
  {
    x: 1860,
    y: 5.102599999999995,
  },
  {
    x: 1880,
    y: 5.102599999999995,
  },
  {
    x: 1900,
    y: 5.037499999999994,
  },
  {
    x: 1920,
    y: 5.037499999999994,
  },
  {
    x: 1940,
    y: 4.972399999999993,
  },
  {
    x: 1960,
    y: 4.972399999999993,
  },
  {
    x: 1980,
    y: 5.037499999999994,
  },
  {
    x: 2000,
    y: 4.972399999999993,
  },
  {
    x: 2020,
    y: 4.972399999999993,
  },
  {
    x: 2040,
    y: 4.972399999999993,
  },
  {
    x: 2060,
    y: 4.972399999999993,
  },
  {
    x: 2080,
    y: 4.972399999999993,
  },
  {
    x: 2100,
    y: 4.972399999999993,
  },
  {
    x: 2120,
    y: 4.972399999999993,
  },
  {
    x: 2140,
    y: 4.972399999999993,
  },
  {
    x: 2160,
    y: 4.972399999999993,
  },
  {
    x: 2180,
    y: 4.972399999999993,
  },
  {
    x: 2200,
    y: 4.972399999999993,
  },
  {
    x: 2220,
    y: 4.972399999999993,
  },
  {
    x: 2240,
    y: 4.972399999999993,
  },
  {
    x: 2260,
    y: 5.037499999999994,
  },
  {
    x: 2280,
    y: 5.037499999999994,
  },
  {
    x: 2300,
    y: 5.037499999999994,
  },
  {
    x: 2320,
    y: 5.037499999999994,
  },
  {
    x: 2340,
    y: 5.037499999999994,
  },
  {
    x: 2360,
    y: 5.037499999999994,
  },
  {
    x: 2380,
    y: 5.037499999999994,
  },
  {
    x: 2400,
    y: 5.102599999999995,
  },
  {
    x: 2420,
    y: 5.102599999999995,
  },
  {
    x: 2440,
    y: 5.102599999999995,
  },
  {
    x: 2460,
    y: 5.102599999999995,
  },
  {
    x: 2480,
    y: 5.102599999999995,
  },
  {
    x: 2500,
    y: 5.102599999999995,
  },
  {
    x: 2520,
    y: 5.102599999999995,
  },
  {
    x: 2540,
    y: 5.102599999999995,
  },
  {
    x: 2560,
    y: 5.167699999999996,
  },
  {
    x: 2580,
    y: 5.167699999999996,
  },
  {
    x: 2600,
    y: 5.167699999999996,
  },
  {
    x: 2620,
    y: 5.167699999999996,
  },
  {
    x: 2640,
    y: 5.167699999999996,
  },
  {
    x: 2660,
    y: 5.167699999999996,
  },
  {
    x: 2680,
    y: 5.167699999999996,
  },
  {
    x: 2700,
    y: 5.167699999999996,
  },
  {
    x: 2720,
    y: 5.167699999999996,
  },
  {
    x: 2740,
    y: 5.167699999999996,
  },
  {
    x: 2760,
    y: 5.167699999999996,
  },
  {
    x: 2780,
    y: 5.167699999999996,
  },
  {
    x: 2800,
    y: 5.167699999999996,
  },
  {
    x: 2820,
    y: 5.167699999999996,
  },
  {
    x: 2840,
    y: 5.167699999999996,
  },
  {
    x: 2860,
    y: 5.167699999999996,
  },
  {
    x: 2880,
    y: 5.167699999999996,
  },
  {
    x: 2900,
    y: 5.167699999999996,
  },
  {
    x: 2920,
    y: 5.167699999999996,
  },
  {
    x: 2940,
    y: 5.167699999999996,
  },
  {
    x: 2960,
    y: 5.167699999999996,
  },
  {
    x: 2980,
    y: 5.167699999999996,
  },
  {
    x: 3000,
    y: 5.167699999999996,
  },
  {
    x: 3020,
    y: 5.167699999999996,
  },
  {
    x: 3040,
    y: 5.167699999999996,
  },
  {
    x: 3060,
    y: 5.167699999999996,
  },
  {
    x: 3080,
    y: 5.167699999999996,
  },
  {
    x: 3100,
    y: 5.167699999999996,
  },
  {
    x: 3120,
    y: 5.167699999999996,
  },
  {
    x: 3140,
    y: 5.167699999999996,
  },
  {
    x: 3160,
    y: 5.167699999999996,
  },
  {
    x: 3180,
    y: 5.167699999999996,
  },
  {
    x: 3200,
    y: 5.167699999999996,
  },
  {
    x: 3220,
    y: 5.167699999999996,
  },
  {
    x: 3240,
    y: 5.167699999999996,
  },
  {
    x: 3260,
    y: 5.167699999999996,
  },
  {
    x: 3280,
    y: 5.167699999999996,
  },
  {
    x: 3300,
    y: 5.167699999999996,
  },
  {
    x: 3320,
    y: 5.167699999999996,
  },
  {
    x: 3340,
    y: 5.167699999999996,
  },
  {
    x: 3360,
    y: 5.167699999999996,
  },
  {
    x: 3380,
    y: 5.167699999999996,
  },
  {
    x: 3400,
    y: 5.167699999999996,
  },
  {
    x: 3420,
    y: 5.167699999999996,
  },
  {
    x: 3440,
    y: 5.167699999999996,
  },
  {
    x: 3460,
    y: 5.167699999999996,
  },
  {
    x: 3480,
    y: 5.167699999999996,
  },
  {
    x: 3500,
    y: 5.167699999999996,
  },
  {
    x: 3520,
    y: 5.167699999999996,
  },
  {
    x: 3540,
    y: 5.167699999999996,
  },
  {
    x: 3560,
    y: 5.167699999999996,
  },
  {
    x: 3580,
    y: 5.102599999999995,
  },
  {
    x: 3600,
    y: 5.167699999999996,
  },
  {
    x: 3620,
    y: 5.167699999999996,
  },
  {
    x: 3640,
    y: 5.102599999999995,
  },
  {
    x: 3660,
    y: 5.167699999999996,
  },
  {
    x: 3680,
    y: 5.167699999999996,
  },
  {
    x: 3700,
    y: 5.167699999999996,
  },
  {
    x: 3720,
    y: 5.167699999999996,
  },
  {
    x: 3740,
    y: 5.2978999999999985,
  },
  {
    x: 3760,
    y: 5.2978999999999985,
  },
  {
    x: 3780,
    y: 5.688500000000005,
  },
  {
    x: 3800,
    y: 6.209300000000013,
  },
  {
    x: 3820,
    y: 7.055599999999998,
  },
  {
    x: 3840,
    y: 8.162299999999988,
  },
  {
    x: 3860,
    y: 9.464300000000009,
  },
  {
    x: 3880,
    y: 11.026700000000005,
  },
  {
    x: 3900,
    y: 12.719300000000004,
  },
  {
    x: 3920,
    y: 13.825999999999993,
  },
  {
    x: 3940,
    y: 14.737400000000008,
  },
  {
    x: 3960,
    y: 15.713899999999995,
  },
  {
    x: 3980,
    y: 16.364900000000006,
  },
  {
    x: 4000,
    y: 16.950799999999987,
  },
  {
    x: 4020,
    y: 17.471599999999995,
  },
  {
    x: 4040,
    y: 18.057500000000005,
  },
  {
    x: 4060,
    y: 18.578300000000013,
  },
  {
    x: 4080,
    y: 19.033999999999992,
  },
  {
    x: 4100,
    y: 19.5548,
  },
  {
    x: 4120,
    y: 20.07560000000001,
  },
  {
    x: 4140,
    y: 20.59639999999999,
  },
  {
    x: 4160,
    y: 20.986999999999995,
  },
  {
    x: 4180,
    y: 21.3776,
  },
  {
    x: 4200,
    y: 21.83330000000001,
  },
  {
    x: 4220,
    y: 22.158800000000014,
  },
  {
    x: 4240,
    y: 22.614499999999992,
  },
  {
    x: 4260,
    y: 23.0051,
  },
  {
    x: 4280,
    y: 23.330600000000004,
  },
  {
    x: 4300,
    y: 23.72120000000001,
  },
  {
    x: 4320,
    y: 24.111799999999988,
  },
  {
    x: 4340,
    y: 24.437299999999993,
  },
  {
    x: 4360,
    y: 24.8279,
  },
  {
    x: 4380,
    y: 25.283600000000007,
  },
  {
    x: 4400,
    y: 25.739300000000014,
  },
  {
    x: 4420,
    y: 26.06479999999999,
  },
  {
    x: 4440,
    y: 26.455399999999997,
  },
  {
    x: 4460,
    y: 26.780900000000003,
  },
  {
    x: 4480,
    y: 27.17150000000001,
  },
  {
    x: 4500,
    y: 27.497000000000014,
  },
  {
    x: 4520,
    y: 27.82249999999999,
  },
  {
    x: 4540,
    y: 28.017799999999994,
  },
  {
    x: 4560,
    y: 28.213099999999997,
  },
  {
    x: 4580,
    y: 28.4084,
  },
  {
    x: 4600,
    y: 28.603700000000003,
  },
  {
    x: 4620,
    y: 28.733900000000006,
  },
  {
    x: 4640,
    y: 25.283600000000007,
  },
  {
    x: 4660,
    y: 22.158800000000014,
  },
  {
    x: 4680,
    y: 21.703100000000006,
  },
  {
    x: 4700,
    y: 22.093700000000013,
  },
  {
    x: 4720,
    y: 22.093700000000013,
  },
  {
    x: 4740,
    y: 21.768200000000007,
  },
  {
    x: 4760,
    y: 21.442700000000002,
  },
  {
    x: 4780,
    y: 21.3776,
  },
  {
    x: 4800,
    y: 21.507800000000003,
  },
  {
    x: 4820,
    y: 21.507800000000003,
  },
  {
    x: 4840,
    y: 21.507800000000003,
  },
  {
    x: 4860,
    y: 21.442700000000002,
  },
  {
    x: 4880,
    y: 21.3776,
  },
  {
    x: 4900,
    y: 21.3776,
  },
  {
    x: 4920,
    y: 21.3125,
  },
  {
    x: 4940,
    y: 21.3125,
  },
  {
    x: 4960,
    y: 21.3125,
  },
  {
    x: 4980,
    y: 21.3125,
  },
  {
    x: 5000,
    y: 21.3125,
  },
  {
    x: 5020,
    y: 21.2474,
  },
  {
    x: 5040,
    y: 21.2474,
  },
  {
    x: 5060,
    y: 17.14609999999999,
  },
  {
    x: 5080,
    y: 7.901900000000012,
  },
  {
    x: 5100,
    y: 5.037499999999994,
  },
  {
    x: 5120,
    y: 4.516699999999986,
  },
  {
    x: 5140,
    y: 4.126100000000008,
  },
  {
    x: 5160,
    y: 4.386500000000012,
  },
  {
    x: 5180,
    y: 4.77709999999999,
  },
  {
    x: 5200,
    y: 5.428100000000001,
  },
  {
    x: 5220,
    y: 6.01400000000001,
  },
  {
    x: 5240,
    y: 6.274399999999986,
  },
  {
    x: 5260,
    y: 6.274399999999986,
  },
  {
    x: 5280,
    y: 6.274399999999986,
  },
  {
    x: 5300,
    y: 6.079100000000011,
  },
  {
    x: 5320,
    y: 5.948900000000009,
  },
  {
    x: 5340,
    y: 5.948900000000009,
  },
  {
    x: 5360,
    y: 5.948900000000009,
  },
  {
    x: 5380,
    y: 5.818700000000007,
  },
  {
    x: 5400,
    y: 5.818700000000007,
  },
  {
    x: 5420,
    y: 5.818700000000007,
  },
  {
    x: 5440,
    y: 5.818700000000007,
  },
  {
    x: 5460,
    y: 5.688500000000005,
  },
  {
    x: 5480,
    y: 5.688500000000005,
  },
  {
    x: 5500,
    y: 5.688500000000005,
  },
  {
    x: 5520,
    y: 5.688500000000005,
  },
  {
    x: 5540,
    y: 5.558300000000003,
  },
  {
    x: 5560,
    y: 5.493200000000002,
  },
  {
    x: 5580,
    y: 5.493200000000002,
  },
  {
    x: 5600,
    y: 5.493200000000002,
  },
  {
    x: 5620,
    y: 5.428100000000001,
  },
  {
    x: 5640,
    y: 5.428100000000001,
  },
  {
    x: 5660,
    y: 5.428100000000001,
  },
  {
    x: 5680,
    y: 5.3629999999999995,
  },
  {
    x: 5700,
    y: 5.3629999999999995,
  },
  {
    x: 5720,
    y: 5.2978999999999985,
  },
  {
    x: 5740,
    y: 5.2327999999999975,
  },
  {
    x: 5760,
    y: 5.167699999999996,
  },
  {
    x: 5780,
    y: 5.2327999999999975,
  },
  {
    x: 5800,
    y: 5.167699999999996,
  },
  {
    x: 5820,
    y: 5.102599999999995,
  },
  {
    x: 5840,
    y: 5.102599999999995,
  },
  {
    x: 5860,
    y: 5.102599999999995,
  },
  {
    x: 5880,
    y: 5.102599999999995,
  },
  {
    x: 5900,
    y: 5.037499999999994,
  },
  {
    x: 5920,
    y: 5.037499999999994,
  },
  {
    x: 5940,
    y: 5.037499999999994,
  },
  {
    x: 5960,
    y: 5.037499999999994,
  },
  {
    x: 5980,
    y: 4.972399999999993,
  },
  {
    x: 6000,
    y: 4.972399999999993,
  },
  {
    x: 6020,
    y: 4.972399999999993,
  },
  {
    x: 6040,
    y: 4.972399999999993,
  },
  {
    x: 6060,
    y: 4.972399999999993,
  },
  {
    x: 6080,
    y: 4.972399999999993,
  },
  {
    x: 6100,
    y: 4.972399999999993,
  },
  {
    x: 6120,
    y: 4.972399999999993,
  },
  {
    x: 6140,
    y: 4.972399999999993,
  },
  {
    x: 6160,
    y: 4.972399999999993,
  },
  {
    x: 6180,
    y: 4.972399999999993,
  },
  {
    x: 6200,
    y: 5.037499999999994,
  },
  {
    x: 6220,
    y: 5.037499999999994,
  },
  {
    x: 6240,
    y: 5.037499999999994,
  },
  {
    x: 6260,
    y: 5.037499999999994,
  },
  {
    x: 6280,
    y: 5.037499999999994,
  },
  {
    x: 6300,
    y: 5.037499999999994,
  },
  {
    x: 6320,
    y: 5.037499999999994,
  },
  {
    x: 6340,
    y: 5.102599999999995,
  },
  {
    x: 6360,
    y: 5.102599999999995,
  },
  {
    x: 6380,
    y: 5.102599999999995,
  },
  {
    x: 6400,
    y: 5.102599999999995,
  },
  {
    x: 6420,
    y: 5.102599999999995,
  },
  {
    x: 6440,
    y: 5.102599999999995,
  },
  {
    x: 6460,
    y: 5.102599999999995,
  },
  {
    x: 6480,
    y: 5.102599999999995,
  },
  {
    x: 6500,
    y: 5.167699999999996,
  },
  {
    x: 6520,
    y: 5.167699999999996,
  },
  {
    x: 6540,
    y: 5.167699999999996,
  },
  {
    x: 6560,
    y: 5.167699999999996,
  },
  {
    x: 6580,
    y: 5.167699999999996,
  },
  {
    x: 6600,
    y: 5.167699999999996,
  },
  {
    x: 6620,
    y: 5.167699999999996,
  },
  {
    x: 6640,
    y: 5.167699999999996,
  },
  {
    x: 6660,
    y: 5.167699999999996,
  },
  {
    x: 6680,
    y: 5.167699999999996,
  },
  {
    x: 6700,
    y: 5.167699999999996,
  },
  {
    x: 6720,
    y: 5.167699999999996,
  },
  {
    x: 6740,
    y: 5.167699999999996,
  },
  {
    x: 6760,
    y: 5.167699999999996,
  },
  {
    x: 6780,
    y: 5.167699999999996,
  },
  {
    x: 6800,
    y: 5.167699999999996,
  },
  {
    x: 6820,
    y: 5.167699999999996,
  },
  {
    x: 6840,
    y: 5.167699999999996,
  },
  {
    x: 6860,
    y: 5.167699999999996,
  },
  {
    x: 6880,
    y: 5.167699999999996,
  },
  {
    x: 6900,
    y: 5.167699999999996,
  },
  {
    x: 6920,
    y: 5.167699999999996,
  },
  {
    x: 6940,
    y: 5.167699999999996,
  },
  {
    x: 6960,
    y: 5.167699999999996,
  },
  {
    x: 6980,
    y: 5.167699999999996,
  },
  {
    x: 7000,
    y: 5.167699999999996,
  },
  {
    x: 7020,
    y: 5.167699999999996,
  },
  {
    x: 7040,
    y: 5.167699999999996,
  },
  {
    x: 7060,
    y: 5.167699999999996,
  },
  {
    x: 7080,
    y: 5.167699999999996,
  },
  {
    x: 7100,
    y: 5.167699999999996,
  },
  {
    x: 7120,
    y: 5.167699999999996,
  },
  {
    x: 7140,
    y: 5.167699999999996,
  },
  {
    x: 7160,
    y: 5.167699999999996,
  },
  {
    x: 7180,
    y: 5.167699999999996,
  },
  {
    x: 7200,
    y: 5.167699999999996,
  },
  {
    x: 7220,
    y: 5.167699999999996,
  },
  {
    x: 7240,
    y: 5.167699999999996,
  },
  {
    x: 7260,
    y: 5.167699999999996,
  },
  {
    x: 7280,
    y: 5.167699999999996,
  },
  {
    x: 7300,
    y: 5.167699999999996,
  },
  {
    x: 7320,
    y: 5.167699999999996,
  },
  {
    x: 7340,
    y: 5.167699999999996,
  },
  {
    x: 7360,
    y: 5.167699999999996,
  },
  {
    x: 7380,
    y: 5.167699999999996,
  },
  {
    x: 7400,
    y: 5.167699999999996,
  },
  {
    x: 7420,
    y: 5.167699999999996,
  },
  {
    x: 7440,
    y: 5.167699999999996,
  },
  {
    x: 7460,
    y: 5.167699999999996,
  },
  {
    x: 7480,
    y: 5.167699999999996,
  },
  {
    x: 7500,
    y: 5.167699999999996,
  },
  {
    x: 7520,
    y: 5.167699999999996,
  },
  {
    x: 7540,
    y: 5.167699999999996,
  },
  {
    x: 7560,
    y: 5.167699999999996,
  },
  {
    x: 7580,
    y: 5.167699999999996,
  },
  {
    x: 7600,
    y: 5.167699999999996,
  },
  {
    x: 7620,
    y: 5.167699999999996,
  },
  {
    x: 7640,
    y: 5.167699999999996,
  },
  {
    x: 7660,
    y: 5.167699999999996,
  },
  {
    x: 7680,
    y: 5.167699999999996,
  },
  {
    x: 7700,
    y: 5.167699999999996,
  },
  {
    x: 7720,
    y: 5.167699999999996,
  },
  {
    x: 7740,
    y: 5.2978999999999985,
  },
  {
    x: 7760,
    y: 5.2978999999999985,
  },
  {
    x: 7780,
    y: 5.493200000000002,
  },
  {
    x: 7800,
    y: 6.144200000000012,
  },
  {
    x: 7820,
    y: 6.990499999999997,
  },
  {
    x: 7840,
    y: 8.097199999999987,
  },
  {
    x: 7860,
    y: 9.399200000000008,
  },
  {
    x: 7880,
    y: 10.896500000000003,
  },
  {
    x: 7900,
    y: 12.654200000000003,
  },
  {
    x: 7920,
    y: 14.021299999999997,
  },
  {
    x: 7940,
    y: 14.86760000000001,
  },
  {
    x: 7960,
    y: 15.583699999999993,
  },
  {
    x: 7980,
    y: 16.299800000000005,
  },
  {
    x: 8000,
    y: 16.885700000000014,
  },
  {
    x: 8020,
    y: 17.471599999999995,
  },
  {
    x: 8040,
    y: 17.927300000000002,
  },
  {
    x: 8060,
    y: 18.44810000000001,
  },
  {
    x: 8080,
    y: 18.96889999999999,
  },
  {
    x: 8100,
    y: 19.4897,
  },
  {
    x: 8120,
    y: 20.010500000000008,
  },
  {
    x: 8140,
    y: 20.466200000000015,
  },
  {
    x: 8160,
    y: 20.986999999999995,
  },
  {
    x: 8180,
    y: 21.442700000000002,
  },
  {
    x: 8200,
    y: 21.703100000000006,
  },
  {
    x: 8220,
    y: 22.158800000000014,
  },
  {
    x: 8240,
    y: 22.54939999999999,
  },
  {
    x: 8260,
    y: 23.0051,
  },
  {
    x: 8280,
    y: 23.330600000000004,
  },
  {
    x: 8300,
    y: 23.72120000000001,
  },
  {
    x: 8320,
    y: 24.111799999999988,
  },
  {
    x: 8340,
    y: 24.567499999999995,
  },
  {
    x: 8360,
    y: 24.893,
  },
  {
    x: 8380,
    y: 25.283600000000007,
  },
  {
    x: 8400,
    y: 25.674200000000013,
  },
  {
    x: 8420,
    y: 25.99969999999999,
  },
  {
    x: 8440,
    y: 26.390299999999996,
  },
  {
    x: 8460,
    y: 26.7158,
  },
  {
    x: 8480,
    y: 27.17150000000001,
  },
  {
    x: 8500,
    y: 27.497000000000014,
  },
  {
    x: 8520,
    y: 27.69229999999999,
  },
  {
    x: 8540,
    y: 28.017799999999994,
  },
  {
    x: 8560,
    y: 28.213099999999997,
  },
  {
    x: 8580,
    y: 28.4084,
  },
  {
    x: 8600,
    y: 28.538600000000002,
  },
  {
    x: 8620,
    y: 28.733900000000006,
  },
  {
    x: 8640,
    y: 24.8279,
  },
  {
    x: 8660,
    y: 22.02860000000001,
  },
  {
    x: 8680,
    y: 22.02860000000001,
  },
  {
    x: 8700,
    y: 22.223900000000015,
  },
  {
    x: 8720,
    y: 22.02860000000001,
  },
  {
    x: 8740,
    y: 21.638000000000005,
  },
  {
    x: 8760,
    y: 21.3776,
  },
  {
    x: 8780,
    y: 21.442700000000002,
  },
  {
    x: 8800,
    y: 21.572900000000004,
  },
  {
    x: 8820,
    y: 21.507800000000003,
  },
  {
    x: 8840,
    y: 21.507800000000003,
  },
  {
    x: 8860,
    y: 21.442700000000002,
  },
  {
    x: 8880,
    y: 21.3776,
  },
  {
    x: 8900,
    y: 21.3776,
  },
  {
    x: 8920,
    y: 21.3776,
  },
  {
    x: 8940,
    y: 21.3776,
  },
  {
    x: 8960,
    y: 21.3776,
  },
  {
    x: 8980,
    y: 21.3125,
  },
  {
    x: 9000,
    y: 21.3125,
  },
  {
    x: 9020,
    y: 21.3125,
  },
  {
    x: 9040,
    y: 21.2474,
  },
  {
    x: 9060,
    y: 18.252800000000008,
  },
  {
    x: 9080,
    y: 8.487799999999993,
  },
  {
    x: 9100,
    y: 4.972399999999993,
  },
  {
    x: 9120,
    y: 4.711999999999989,
  },
  {
    x: 9140,
    y: 3.995900000000006,
  },
  {
    x: 9160,
    y: 4.516699999999986,
  },
  {
    x: 9180,
    y: 4.711999999999989,
  },
  {
    x: 9200,
    y: 5.2327999999999975,
  },
  {
    x: 9220,
    y: 5.883800000000008,
  },
  {
    x: 9240,
    y: 6.339499999999987,
  },
  {
    x: 9260,
    y: 6.339499999999987,
  },
  {
    x: 9280,
    y: 6.274399999999986,
  },
  {
    x: 9300,
    y: 6.144200000000012,
  },
  {
    x: 9320,
    y: 6.144200000000012,
  },
  {
    x: 9340,
    y: 6.079100000000011,
  },
  {
    x: 9360,
    y: 5.883800000000008,
  },
  {
    x: 9380,
    y: 5.818700000000007,
  },
  {
    x: 9400,
    y: 5.948900000000009,
  },
  {
    x: 9420,
    y: 5.883800000000008,
  },
  {
    x: 9440,
    y: 5.818700000000007,
  },
  {
    x: 9460,
    y: 5.818700000000007,
  },
  {
    x: 9480,
    y: 5.688500000000005,
  },
  {
    x: 9500,
    y: 5.688500000000005,
  },
  {
    x: 9520,
    y: 5.623400000000004,
  },
  {
    x: 9540,
    y: 5.623400000000004,
  },
  {
    x: 9560,
    y: 5.623400000000004,
  },
  {
    x: 9580,
    y: 5.493200000000002,
  },
  {
    x: 9600,
    y: 5.493200000000002,
  },
  {
    x: 9620,
    y: 5.493200000000002,
  },
  {
    x: 9640,
    y: 5.428100000000001,
  },
  {
    x: 9660,
    y: 5.428100000000001,
  },
  {
    x: 9680,
    y: 5.2978999999999985,
  },
  {
    x: 9700,
    y: 5.2978999999999985,
  },
  {
    x: 9720,
    y: 5.2978999999999985,
  },
  {
    x: 9740,
    y: 5.2327999999999975,
  },
  {
    x: 9760,
    y: 5.2327999999999975,
  },
  {
    x: 9780,
    y: 5.167699999999996,
  },
  {
    x: 9800,
    y: 5.167699999999996,
  },
  {
    x: 9820,
    y: 5.102599999999995,
  },
  {
    x: 9840,
    y: 5.102599999999995,
  },
  {
    x: 9860,
    y: 5.102599999999995,
  },
  {
    x: 9880,
    y: 5.102599999999995,
  },
  {
    x: 9900,
    y: 5.037499999999994,
  },
  {
    x: 9920,
    y: 5.037499999999994,
  },
  {
    x: 9940,
    y: 5.037499999999994,
  },
  {
    x: 9960,
    y: 4.972399999999993,
  },
  {
    x: 9980,
    y: 4.972399999999993,
  },
  {
    x: 10000,
    y: 4.972399999999993,
  },
  {
    x: 10020,
    y: 4.972399999999993,
  },
  {
    x: 10040,
    y: 4.972399999999993,
  },
  {
    x: 10060,
    y: 4.972399999999993,
  },
  {
    x: 10080,
    y: 4.972399999999993,
  },
  {
    x: 10100,
    y: 4.972399999999993,
  },
  {
    x: 10120,
    y: 4.972399999999993,
  },
  {
    x: 10140,
    y: 4.972399999999993,
  },
  {
    x: 10160,
    y: 4.972399999999993,
  },
  {
    x: 10180,
    y: 4.972399999999993,
  },
  {
    x: 10200,
    y: 4.972399999999993,
  },
  {
    x: 10220,
    y: 4.972399999999993,
  },
  {
    x: 10240,
    y: 5.037499999999994,
  },
  {
    x: 10260,
    y: 5.037499999999994,
  },
  {
    x: 10280,
    y: 5.037499999999994,
  },
  {
    x: 10300,
    y: 5.037499999999994,
  },
  {
    x: 10320,
    y: 5.037499999999994,
  },
  {
    x: 10340,
    y: 5.037499999999994,
  },
  {
    x: 10360,
    y: 5.102599999999995,
  },
  {
    x: 10380,
    y: 5.102599999999995,
  },
  {
    x: 10400,
    y: 5.102599999999995,
  },
  {
    x: 10420,
    y: 5.102599999999995,
  },
  {
    x: 10440,
    y: 5.102599999999995,
  },
  {
    x: 10460,
    y: 5.102599999999995,
  },
  {
    x: 10480,
    y: 5.102599999999995,
  },
  {
    x: 10500,
    y: 5.102599999999995,
  },
  {
    x: 10520,
    y: 5.102599999999995,
  },
  {
    x: 10540,
    y: 5.167699999999996,
  },
  {
    x: 10560,
    y: 5.167699999999996,
  },
  {
    x: 10580,
    y: 5.167699999999996,
  },
  {
    x: 10600,
    y: 5.167699999999996,
  },
  {
    x: 10620,
    y: 5.167699999999996,
  },
  {
    x: 10640,
    y: 5.167699999999996,
  },
  {
    x: 10660,
    y: 5.167699999999996,
  },
  {
    x: 10680,
    y: 5.167699999999996,
  },
  {
    x: 10700,
    y: 5.167699999999996,
  },
  {
    x: 10720,
    y: 5.167699999999996,
  },
  {
    x: 10740,
    y: 5.167699999999996,
  },
  {
    x: 10760,
    y: 5.167699999999996,
  },
  {
    x: 10780,
    y: 5.167699999999996,
  },
  {
    x: 10800,
    y: 5.167699999999996,
  },
  {
    x: 10820,
    y: 5.167699999999996,
  },
  {
    x: 10840,
    y: 5.167699999999996,
  },
  {
    x: 10860,
    y: 5.167699999999996,
  },
  {
    x: 10880,
    y: 5.167699999999996,
  },
  {
    x: 10900,
    y: 5.167699999999996,
  },
  {
    x: 10920,
    y: 5.167699999999996,
  },
  {
    x: 10940,
    y: 5.167699999999996,
  },
  {
    x: 10960,
    y: 5.167699999999996,
  },
  {
    x: 10980,
    y: 5.167699999999996,
  },
  {
    x: 11000,
    y: 5.167699999999996,
  },
  {
    x: 11020,
    y: 5.167699999999996,
  },
  {
    x: 11040,
    y: 5.167699999999996,
  },
  {
    x: 11060,
    y: 5.167699999999996,
  },
  {
    x: 11080,
    y: 5.167699999999996,
  },
  {
    x: 11100,
    y: 5.167699999999996,
  },
  {
    x: 11120,
    y: 5.167699999999996,
  },
  {
    x: 11140,
    y: 5.167699999999996,
  },
  {
    x: 11160,
    y: 5.167699999999996,
  },
  {
    x: 11180,
    y: 5.167699999999996,
  },
  {
    x: 11200,
    y: 5.167699999999996,
  },
  {
    x: 11220,
    y: 5.167699999999996,
  },
  {
    x: 11240,
    y: 5.167699999999996,
  },
  {
    x: 11260,
    y: 5.167699999999996,
  },
  {
    x: 11280,
    y: 5.167699999999996,
  },
  {
    x: 11300,
    y: 5.167699999999996,
  },
  {
    x: 11320,
    y: 5.167699999999996,
  },
  {
    x: 11340,
    y: 5.167699999999996,
  },
  {
    x: 11360,
    y: 5.167699999999996,
  },
  {
    x: 11380,
    y: 5.167699999999996,
  },
  {
    x: 11400,
    y: 5.167699999999996,
  },
  {
    x: 11420,
    y: 5.167699999999996,
  },
  {
    x: 11440,
    y: 5.167699999999996,
  },
  {
    x: 11460,
    y: 5.167699999999996,
  },
  {
    x: 11480,
    y: 5.167699999999996,
  },
  {
    x: 11500,
    y: 5.167699999999996,
  },
  {
    x: 11520,
    y: 5.167699999999996,
  },
  {
    x: 11540,
    y: 5.167699999999996,
  },
  {
    x: 11560,
    y: 5.167699999999996,
  },
  {
    x: 11580,
    y: 5.167699999999996,
  },
  {
    x: 11600,
    y: 5.167699999999996,
  },
  {
    x: 11620,
    y: 5.167699999999996,
  },
  {
    x: 11640,
    y: 5.167699999999996,
  },
  {
    x: 11660,
    y: 5.167699999999996,
  },
  {
    x: 11680,
    y: 5.167699999999996,
  },
  {
    x: 11700,
    y: 5.167699999999996,
  },
  {
    x: 11720,
    y: 5.167699999999996,
  },
  {
    x: 11740,
    y: 5.2978999999999985,
  },
  {
    x: 11760,
    y: 5.167699999999996,
  },
  {
    x: 11780,
    y: 5.493200000000002,
  },
  {
    x: 11800,
    y: 6.079100000000011,
  },
  {
    x: 11820,
    y: 6.925399999999996,
  },
  {
    x: 11840,
    y: 7.967000000000013,
  },
  {
    x: 11860,
    y: 9.203900000000004,
  },
  {
    x: 11880,
    y: 10.636099999999999,
  },
  {
    x: 11900,
    y: 12.4589,
  },
  {
    x: 11920,
    y: 13.760899999999992,
  },
  {
    x: 11940,
    y: 14.737400000000008,
  },
  {
    x: 11960,
    y: 15.518599999999992,
  },
  {
    x: 11980,
    y: 16.299800000000005,
  },
  {
    x: 12000,
    y: 16.820600000000013,
  },
  {
    x: 12020,
    y: 17.406499999999994,
  },
  {
    x: 12040,
    y: 17.992400000000004,
  },
  {
    x: 12060,
    y: 18.578300000000013,
  },
  {
    x: 12080,
    y: 19.099099999999993,
  },
  {
    x: 12100,
    y: 19.5548,
  },
  {
    x: 12120,
    y: 20.010500000000008,
  },
  {
    x: 12140,
    y: 20.336000000000013,
  },
  {
    x: 12160,
    y: 20.72659999999999,
  },
  {
    x: 12180,
    y: 21.2474,
  },
  {
    x: 12200,
    y: 21.638000000000005,
  },
  {
    x: 12220,
    y: 22.158800000000014,
  },
  {
    x: 12240,
    y: 22.48429999999999,
  },
  {
    x: 12260,
    y: 22.939999999999998,
  },
  {
    x: 12280,
    y: 23.330600000000004,
  },
  {
    x: 12300,
    y: 23.72120000000001,
  },
  {
    x: 12320,
    y: 24.111799999999988,
  },
  {
    x: 12340,
    y: 24.567499999999995,
  },
  {
    x: 12360,
    y: 24.893,
  },
  {
    x: 12380,
    y: 25.283600000000007,
  },
  {
    x: 12400,
    y: 25.47890000000001,
  },
  {
    x: 12420,
    y: 25.93459999999999,
  },
  {
    x: 12440,
    y: 26.390299999999996,
  },
  {
    x: 12460,
    y: 26.780900000000003,
  },
  {
    x: 12480,
    y: 27.106400000000008,
  },
  {
    x: 12500,
    y: 27.431900000000013,
  },
  {
    x: 12520,
    y: 27.69229999999999,
  },
  {
    x: 12540,
    y: 27.887599999999992,
  },
  {
    x: 12560,
    y: 28.147999999999996,
  },
  {
    x: 12580,
    y: 28.4084,
  },
  {
    x: 12600,
    y: 28.603700000000003,
  },
  {
    x: 12620,
    y: 28.733900000000006,
  },
  {
    x: 12640,
    y: 24.893,
  },
  {
    x: 12660,
    y: 22.41919999999999,
  },
  {
    x: 12680,
    y: 22.35409999999999,
  },
  {
    x: 12700,
    y: 22.35409999999999,
  },
  {
    x: 12720,
    y: 21.89840000000001,
  },
  {
    x: 12740,
    y: 21.442700000000002,
  },
  {
    x: 12760,
    y: 21.3776,
  },
  {
    x: 12780,
    y: 21.507800000000003,
  },
  {
    x: 12800,
    y: 21.572900000000004,
  },
  {
    x: 12820,
    y: 21.507800000000003,
  },
  {
    x: 12840,
    y: 21.442700000000002,
  },
  {
    x: 12860,
    y: 21.442700000000002,
  },
  {
    x: 12880,
    y: 21.3776,
  },
  {
    x: 12900,
    y: 21.3776,
  },
  {
    x: 12920,
    y: 21.3776,
  },
  {
    x: 12940,
    y: 21.3776,
  },
  {
    x: 12960,
    y: 21.3776,
  },
  {
    x: 12980,
    y: 21.3125,
  },
  {
    x: 13000,
    y: 21.3125,
  },
  {
    x: 13020,
    y: 21.3125,
  },
  {
    x: 13040,
    y: 21.182299999999998,
  },
  {
    x: 13060,
    y: 20.010500000000008,
  },
  {
    x: 13080,
    y: 9.203900000000004,
  },
  {
    x: 13100,
    y: 5.037499999999994,
  },
  {
    x: 13120,
    y: 4.321400000000011,
  },
  {
    x: 13140,
    y: 4.061000000000007,
  },
  {
    x: 13160,
    y: 4.451600000000013,
  },
  {
    x: 13180,
    y: 4.711999999999989,
  },
  {
    x: 13200,
    y: 5.167699999999996,
  },
  {
    x: 13220,
    y: 5.818700000000007,
  },
  {
    x: 13240,
    y: 6.404599999999988,
  },
  {
    x: 13260,
    y: 6.339499999999987,
  },
  {
    x: 13280,
    y: 6.144200000000012,
  },
  {
    x: 13300,
    y: 6.079100000000011,
  },
  {
    x: 13320,
    y: 5.948900000000009,
  },
  {
    x: 13340,
    y: 5.883800000000008,
  },
  {
    x: 13360,
    y: 5.883800000000008,
  },
  {
    x: 13380,
    y: 5.818700000000007,
  },
  {
    x: 13400,
    y: 5.883800000000008,
  },
  {
    x: 13420,
    y: 5.818700000000007,
  },
  {
    x: 13440,
    y: 5.818700000000007,
  },
  {
    x: 13460,
    y: 5.818700000000007,
  },
  {
    x: 13480,
    y: 5.753600000000006,
  },
  {
    x: 13500,
    y: 5.688500000000005,
  },
  {
    x: 13520,
    y: 5.688500000000005,
  },
  {
    x: 13540,
    y: 5.623400000000004,
  },
  {
    x: 13560,
    y: 5.623400000000004,
  },
  {
    x: 13580,
    y: 5.558300000000003,
  },
  {
    x: 13600,
    y: 5.493200000000002,
  },
  {
    x: 13620,
    y: 5.428100000000001,
  },
  {
    x: 13640,
    y: 5.428100000000001,
  },
  {
    x: 13660,
    y: 5.428100000000001,
  },
  {
    x: 13680,
    y: 5.428100000000001,
  },
  {
    x: 13700,
    y: 5.2978999999999985,
  },
  {
    x: 13720,
    y: 5.2978999999999985,
  },
  {
    x: 13740,
    y: 5.2978999999999985,
  },
  {
    x: 13760,
    y: 5.167699999999996,
  },
  {
    x: 13780,
    y: 5.167699999999996,
  },
  {
    x: 13800,
    y: 5.167699999999996,
  },
  {
    x: 13820,
    y: 5.102599999999995,
  },
  {
    x: 13840,
    y: 5.102599999999995,
  },
  {
    x: 13860,
    y: 5.102599999999995,
  },
  {
    x: 13880,
    y: 5.102599999999995,
  },
  {
    x: 13900,
    y: 5.037499999999994,
  },
  {
    x: 13920,
    y: 5.037499999999994,
  },
  {
    x: 13940,
    y: 5.037499999999994,
  },
  {
    x: 13960,
    y: 5.037499999999994,
  },
  {
    x: 13980,
    y: 4.972399999999993,
  },
  {
    x: 14000,
    y: 4.972399999999993,
  },
  {
    x: 14020,
    y: 4.972399999999993,
  },
  {
    x: 14040,
    y: 4.972399999999993,
  },
  {
    x: 14060,
    y: 4.972399999999993,
  },
  {
    x: 14080,
    y: 4.972399999999993,
  },
  {
    x: 14100,
    y: 4.972399999999993,
  },
  {
    x: 14120,
    y: 4.972399999999993,
  },
  {
    x: 14140,
    y: 4.972399999999993,
  },
  {
    x: 14160,
    y: 4.972399999999993,
  },
  {
    x: 14180,
    y: 4.972399999999993,
  },
  {
    x: 14200,
    y: 4.972399999999993,
  },
  {
    x: 14220,
    y: 4.972399999999993,
  },
  {
    x: 14240,
    y: 5.037499999999994,
  },
  {
    x: 14260,
    y: 5.037499999999994,
  },
  {
    x: 14280,
    y: 5.037499999999994,
  },
  {
    x: 14300,
    y: 5.037499999999994,
  },
  {
    x: 14320,
    y: 5.037499999999994,
  },
  {
    x: 14340,
    y: 5.102599999999995,
  },
  {
    x: 14360,
    y: 5.037499999999994,
  },
  {
    x: 14380,
    y: 5.037499999999994,
  },
  {
    x: 14400,
    y: 5.102599999999995,
  },
  {
    x: 14420,
    y: 5.102599999999995,
  },
  {
    x: 14440,
    y: 5.102599999999995,
  },
  {
    x: 14460,
    y: 5.102599999999995,
  },
  {
    x: 14480,
    y: 5.102599999999995,
  },
  {
    x: 14500,
    y: 5.102599999999995,
  },
  {
    x: 14520,
    y: 5.102599999999995,
  },
  {
    x: 14540,
    y: 5.102599999999995,
  },
  {
    x: 14560,
    y: 5.167699999999996,
  },
  {
    x: 14580,
    y: 5.167699999999996,
  },
  {
    x: 14600,
    y: 5.167699999999996,
  },
  {
    x: 14620,
    y: 5.167699999999996,
  },
  {
    x: 14640,
    y: 5.167699999999996,
  },
  {
    x: 14660,
    y: 5.167699999999996,
  },
  {
    x: 14680,
    y: 5.167699999999996,
  },
  {
    x: 14700,
    y: 5.167699999999996,
  },
  {
    x: 14720,
    y: 5.167699999999996,
  },
  {
    x: 14740,
    y: 5.167699999999996,
  },
  {
    x: 14760,
    y: 5.167699999999996,
  },
  {
    x: 14780,
    y: 5.167699999999996,
  },
  {
    x: 14800,
    y: 5.167699999999996,
  },
  {
    x: 14820,
    y: 5.167699999999996,
  },
  {
    x: 14840,
    y: 5.167699999999996,
  },
  {
    x: 14860,
    y: 5.167699999999996,
  },
  {
    x: 14880,
    y: 5.167699999999996,
  },
  {
    x: 14900,
    y: 5.167699999999996,
  },
  {
    x: 14920,
    y: 5.167699999999996,
  },
  {
    x: 14940,
    y: 5.167699999999996,
  },
  {
    x: 14960,
    y: 5.167699999999996,
  },
  {
    x: 14980,
    y: 5.167699999999996,
  },
  {
    x: 15000,
    y: 5.167699999999996,
  },
  {
    x: 15020,
    y: 5.167699999999996,
  },
  {
    x: 15040,
    y: 5.167699999999996,
  },
  {
    x: 15060,
    y: 5.167699999999996,
  },
  {
    x: 15080,
    y: 5.167699999999996,
  },
  {
    x: 15100,
    y: 5.167699999999996,
  },
  {
    x: 15120,
    y: 5.167699999999996,
  },
  {
    x: 15140,
    y: 5.167699999999996,
  },
  {
    x: 15160,
    y: 5.167699999999996,
  },
  {
    x: 15180,
    y: 5.167699999999996,
  },
  {
    x: 15200,
    y: 5.167699999999996,
  },
  {
    x: 15220,
    y: 5.102599999999995,
  },
  {
    x: 15240,
    y: 5.102599999999995,
  },
  {
    x: 15260,
    y: 5.167699999999996,
  },
  {
    x: 15280,
    y: 5.167699999999996,
  },
  {
    x: 15300,
    y: 5.102599999999995,
  },
  {
    x: 15320,
    y: 5.102599999999995,
  },
  {
    x: 15340,
    y: 5.167699999999996,
  },
  {
    x: 15360,
    y: 5.167699999999996,
  },
  {
    x: 15380,
    y: 5.167699999999996,
  },
  {
    x: 15400,
    y: 5.167699999999996,
  },
  {
    x: 15420,
    y: 5.167699999999996,
  },
  {
    x: 15440,
    y: 5.102599999999995,
  },
  {
    x: 15460,
    y: 5.102599999999995,
  },
  {
    x: 15480,
    y: 5.167699999999996,
  },
  {
    x: 15500,
    y: 5.102599999999995,
  },
  {
    x: 15520,
    y: 5.102599999999995,
  },
  {
    x: 15540,
    y: 5.102599999999995,
  },
  {
    x: 15560,
    y: 5.167699999999996,
  },
  {
    x: 15580,
    y: 5.167699999999996,
  },
  {
    x: 15600,
    y: 5.167699999999996,
  },
  {
    x: 15620,
    y: 5.167699999999996,
  },
  {
    x: 15640,
    y: 5.102599999999995,
  },
  {
    x: 15660,
    y: 5.102599999999995,
  },
  {
    x: 15680,
    y: 5.102599999999995,
  },
  {
    x: 15700,
    y: 5.102599999999995,
  },
  {
    x: 15720,
    y: 5.102599999999995,
  },
  {
    x: 15740,
    y: 5.493200000000002,
  },
  {
    x: 15760,
    y: 5.167699999999996,
  },
  {
    x: 15780,
    y: 5.428100000000001,
  },
  {
    x: 15800,
    y: 6.01400000000001,
  },
  {
    x: 15820,
    y: 6.795199999999994,
  },
  {
    x: 15840,
    y: 7.836800000000011,
  },
  {
    x: 15860,
    y: 9.008600000000001,
  },
  {
    x: 15880,
    y: 10.505899999999997,
  },
  {
    x: 15900,
    y: 12.198499999999996,
  },
  {
    x: 15920,
    y: 13.63069999999999,
  },
  {
    x: 15940,
    y: 14.672300000000007,
  },
  {
    x: 15960,
    y: 15.518599999999992,
  },
  {
    x: 15980,
    y: 16.169600000000003,
  },
];
